import { Globals } from "../CoreApp/Globals.js";

export function ConvertToGrayscaleImage(imageObj) {
  var context = Globals._maskCanvas.getContext("2d");

  context.drawImage(imageObj, 0, 0);

  var imageData = context.getImageData(0, 0, imageObj.width, imageObj.height);
  var data = imageData.data;

  for (var i = 0; i < data.length; i += 4) {
    var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
    // red
    data[i] = brightness;
    // green
    data[i + 1] = brightness;
    // blue
    data[i + 2] = brightness;
  }

  // overwrite original image
  context.putImageData(imageData, 0, 0);
  //var grayImage = new Image();
  //grayImage.src = gMaskCanvas.toDataURL("image/png");
  //return grayImage
}
